import { render, staticRenderFns } from "./LaboratoryReport.vue?vue&type=template&id=6a9da8a6&scoped=true&"
import script from "./LaboratoryReport.vue?vue&type=script&lang=ts&"
export * from "./LaboratoryReport.vue?vue&type=script&lang=ts&"
import style0 from "./LaboratoryReport.vue?vue&type=style&index=0&id=6a9da8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9da8a6",
  null
  
)

export default component.exports